{{#if this.noAccess}}
  <CustomWizardNoAccess
    @text={{i18n this.noAccessI18nKey}}
    @wizardId={{this.wizardId}}
    @reason={{this.noAccessReason}}
  />
{{/if}}